module.exports = __webpack_public_path__ + "static/media/SF-1-A (1).fca22a6b.mp3";